function pad2(value) {
  return String(value).padStart(2, '0');
}

function formatDate(d) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

function midnight(ref = new Date()) {
  return new Date(ref.getFullYear(), ref.getMonth(), ref.getDate());
}

function shiftDays(base, n) {
  const d = new Date(base.getFullYear(), base.getMonth(), base.getDate());
  d.setDate(d.getDate() + n);
  return d;
}

function getMonday(base) {
  const d = midnight(base);
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  return d;
}

function getLastDayOfMonth(year, month) {
  return new Date(year, month + 1, 0);
}

const BUILDERS = {
  today: (r) => { const f = shiftDays(r, 0); return { from: f, to: f }; },
  tomorrow: (r) => { const f = shiftDays(r, 1); return { from: f, to: f }; },
  day_after_tomorrow: (r) => { const f = shiftDays(r, 2); return { from: f, to: f }; },
  yesterday: (r) => { const f = shiftDays(r, -1); return { from: f, to: f }; },
  this_week: (r) => { const m = getMonday(r); return { from: m, to: shiftDays(m, 6) }; },
  prev_week: (r) => { const m = shiftDays(getMonday(r), -7); return { from: m, to: shiftDays(m, 6) }; },
  next_week: (r) => { const m = shiftDays(getMonday(r), 7); return { from: m, to: shiftDays(m, 6) }; },
  this_month: (r) => ({ from: new Date(r.getFullYear(), r.getMonth(), 1), to: getLastDayOfMonth(r.getFullYear(), r.getMonth()) }),
  plus3: (r) => ({ from: shiftDays(r, 0), to: shiftDays(r, 3) }),
  minus3: (r) => ({ from: shiftDays(r, -3), to: shiftDays(r, 0) }),
};

export const PERIOD_PRESETS = [
  { key: 'today', label: 'Сегодня' },
  { key: 'tomorrow', label: 'Завтра' },
  { key: 'day_after_tomorrow', label: 'Послезавтра' },
  { key: 'yesterday', label: 'Вчера' },
  { key: 'this_week', label: 'Тек. неделя' },
  { key: 'prev_week', label: 'Прош. неделя' },
  { key: 'next_week', label: 'След. неделя' },
  { key: 'this_month', label: 'Тек. месяц' },
  { key: 'plus3', label: '+3 дня' },
  { key: 'minus3', label: '-3 дня' },
];

export function isKnownPeriod(key) {
  return typeof key === 'string' && Object.prototype.hasOwnProperty.call(BUILDERS, key);
}

export function resolvePeriodRange(key, ref = new Date()) {
  const builder = BUILDERS[key];
  if (!builder) return null;
  const { from, to } = builder(midnight(ref));
  return { from: formatDate(from), to: formatDate(to) };
}
